import { isLocalUrl, validateWindowSize } from '../helpers/helpers';
export default function circleCards() {
  const widgetName = 'circleCards';
  const widgetOpts = circleCardsOpts;
  const wrapContainerClass = 'circleCards-container-wrapper';
  const $widget = $(`#${widgetName}`);

  $widget.wrap(`<div class="${wrapContainerClass}"><div class="inner-container"></div></div>`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: validateWindowSize(800) ? [] : ['all'],
    showDescription: false,
    moreButton: true,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    textOverImage: true,
    maxItemsVisible: 4,
    itemsPerPanel: 1,
    buyNowButton: false,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomCards(data.items);
      } else {
        $(`.${wrapContainerClass}`).remove();
      }
    },
  });

  function createCustomCards(widgetData) {
    $widget.find('.image-container').append('<div class="overlay"></div>');
    $widget.find('.card-content').remove();

    $widget.find('.card-widget-item').each(function (x) {
      const { Title, Description, URL } = widgetData[x];
      let urlAttribute = isLocalUrl(URL) ? '' : 'target="_blank"';

      const $cardItem = $(this);

      $cardItem.append(`
          <div class="card-content">
            <div class="widget-title-wrapper">
              <h3 class="widget-title">${Title}</h3>
            </div>
            <div class="hover-content">
              ${Description ? `<p class="widget-description">${Description}</p>` : ''}
              ${URL ? `<a href="${URL}" class="button" ${urlAttribute}>More</a>` : ''}
            </div>
          </div>`);

      if (isLocalUrl(URL)) {
        $cardItem.removeAttr('target');
      }

      if (!URL) {
        $cardItem.addClass('empty-card').removeAttr('href');
      }
    });
  }
}
